import React from 'react';
import PropTypes from 'prop-types';

function Pager(props) {
  const { pages, pageOffset, goToPage } = props;
  const goToFirst = pageOffset > 0
    ? (
      <li className="paginator__item first">
        <button
          type="button"
          className="paginator__btn paginator__btn--first visible"
          onClick={() => goToPage(1)}
        >
          Primera
        </button>
      </li>
    ) : null;
  const goToLast = pageOffset + 1 < pages
    ? (
      <li className="paginator__item last">
        <button
          type="button"
          className="paginator__btn paginator__btn--last visible"
          onClick={() => goToPage(pages)}
        >
          Última
        </button>
      </li>
    ) : null;

  const range = pages > 2 ? 2 : 1;
  // We assume we're in the first page.
  let pageFirst = 1;
  let pageLast = pageFirst + range;
  if (pageOffset + 1 === pages) {
    // If we're in the last page.
    pageFirst = pages - range;
    pageLast = pages;
  } else if (pageOffset > 0) {
    pageFirst = pageOffset;
    pageLast = pageOffset + 2;
  }

  const pageList = [];
  for (let i = pageFirst; i <= pageLast; i += 1) {
    let itemClasses = 'paginator__item';
    let buttonClasses = 'paginator__btn paginator__btn-number';
    if (i === pageOffset + 1) {
      itemClasses += ' active';
      buttonClasses += ' active';
    }
    pageList.push((
      <li className={itemClasses} key={i}>
        <button type="button" className={buttonClasses} onClick={() => goToPage(i)}>{i}</button>
      </li>
    ));
  }
  return (
    <div className="paginator-wrapper">
      <ul className="paginator-wrapper__list">
        {goToFirst}
        {pageList}
        {goToLast}
      </ul>
    </div>
  );
}

Pager.propTypes = {
  pages: PropTypes.number.isRequired,
  pageOffset: PropTypes.number.isRequired,
  goToPage: PropTypes.func.isRequired,
};

export default Pager;
